import React, { useState, useEffect } from 'react'
import { Box, Paper, Loader, Text, Grid, Group, ThemeIcon } from '@mantine/core'
import { getDataStatsUserCitySignup } from '../../../services/dashboard'
import { PieChart } from '@mantine/charts'
import { IconPointFilled } from '@tabler/icons-react'

const DashboardStatsCitySignup = () => {
  const [loadingStatistic, setLoadingStatistic] = useState(true)
  const [statsCitySignUp, setStatsCitySignUp] = useState([])

  const getRandomColor = () => {
    const letter = '0123456789ABCDEF'
    let color = '#'
    for (let i = 0; i < 6; i++) {
      color += letter[Math.floor(Math.random() * 16)]
    }
    return color
  }

  const handleGetStatsUserCitySignup = async () => {
    setLoadingStatistic(true)
    try {
      const response = await getDataStatsUserCitySignup()
      if (response?.data) {
        const responseStats = response.data.managementStats.user.citySignUp || []
        const remapData = responseStats.map((val) => {
          return {
            ...val,
            value: val.count,
            color: getRandomColor()
          }
        })
        setStatsCitySignUp(remapData)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingStatistic(false)
    }
  }

  useEffect(() => {
    handleGetStatsUserCitySignup()
    // eslint-disable-next-line
  }, [])

  const loadingDataStats = () => {
    return (
      <Box ta='center' my={165}>
        <Loader size='sm' />
        <Text c='gray.6' fz={14}>Loading Data</Text>
      </Box>
    )
  }

  const loadLayoutStats = () => {
    const mappingDataCity = (data) => {
      if (data.length > 0) {
        const remap = data.map((val, index) => {
          return (
            <Group gap={2}>
              <ThemeIcon variant="white" size='lg' color={val.color}>
                <IconPointFilled style={{ width: '70%', height: '70%' }} />
              </ThemeIcon>
              <Text fz={12} fw='500'>{val.name}</Text>
            </Group>
          )
        })
        return remap
      }
    }

    return (
      <Box>
        <Grid align='flex-start'>
          <Grid.Col span={{ base: 12, md: 5, lg: 5 }}>
            <Box>
              {mappingDataCity(statsCitySignUp)}
            </Box>
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 7, lg: 7 }}>
            <PieChart
              size={260}
              data={statsCitySignUp}
              labelPosition='outside'
              labelsType='percent'
              withLabels
              withTooltip tooltipDataSource="segment"
            />
          </Grid.Col>
        </Grid>
      </Box>
    )
  }


  return (
    <Paper shadow="sm" p='md' withBorder radius='md'>
      <Text fz='md' fw='bold' mb='md'>City Signup User Demography</Text>
      <Box my={20}>
        {loadingStatistic ? loadingDataStats() : loadLayoutStats()}
      </Box>
    </Paper>
  )
}

export default DashboardStatsCitySignup